import React, { useEffect, useState, useRef } from 'react'
import '.././App.css';
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc, getDocs, deleteDoc, doc, setDoc, where, limit, getCountFromServer, updateDoc, writeBatch, getAggregateFromServer, sum } from 'firebase/firestore'
import Select from 'react-select'
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';

function TableOrders() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });
  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  })

  const [userData, setUserData] = useState();
  const [seatingCat, setseatingCat] = useState([]);
  const [seatings, setseatings] = useState([]);
  const [productCat, setproductCat] = useState([]);
  const [products, setproducts] = useState([]);
  const [orderitems, setorderitems] = useState([]);
  const [customers, setcustomers] = useState([]);
  const [staffs, setstaffs] = useState([]);

  const [name, setname] = useState("");
  const [mobile, setmobile] = useState("");
  const [address, setaddress] = useState("");

  const [barcode, setbarcode] = useState("");
  const [orderDocid, setorderDocid] = useState("");
  const [tableid, settableid] = useState("");
  const [tablename, settablename] = useState("");
  const [orderdate, setorderdate] = useState("");
  const [custid, setcustid] = useState("");
  const [customer, setcustomer] = useState("");
  const [staffid, setstaffid] = useState("");
  const [staff, setstaff] = useState("");
  const [billno, setbillno] = useState("");
  const [tablebillno, settablebillno] = useState("");
  const [totalamount, settotalamount] = useState(0);
  const [discount, setdiscount] = useState(0);
  const [paid, setpaid] = useState(0);
  const [remaining, setremaining] = useState("");
  const [paytype, setpaytype] = useState("");

  const [revrem, setrevrem] = useState(0);


  const [selectedProduct, setSelectedProduct] = useState(null);
  const [stockQty, setStockQty] = useState("");
  const [currentStock, setCurrentStock] = useState(0);
  const [item, setitem] = useState("");
  const [itemid, setitemid] = useState("");

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUserData(user);
    });
  });


  useEffect(() => {
    finaltotal()
    fetchData1();
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    setorderdate(formattedDate);
  }, []);


  const fetchData1 = async () => {
    try {
      // Queries
      const seatingCatsQ = query(collection(db, 'seatingcats'), orderBy("created", "asc"));
      const seatingsQ = query(collection(db, 'seatings'), orderBy("created", "asc"));
      const productsQ = query(collection(db, 'products'), orderBy("prodname", "asc"));

      // Static collections
      const productCatsQ = getDocs(collection(db, 'productcats'));
      const customersQ = getDocs(query(collection(db, 'customers'), orderBy("created", "desc")));
      const staffsQ = getDocs(query(collection(db, 'staffs'), orderBy("created", "desc")));
      const unitsQ = getDocs(collection(db, 'productunits'));

      // Run static fetches in parallel
      const [productCatSnap, customersSnap, staffsSnap, unitSnap] = await Promise.all([
        productCatsQ,
        customersQ,
        staffsQ,
        unitsQ,
      ]);

      // Update state from static fetches
      setproductCat(productCatSnap.docs.map(doc => ({ id: doc.id, data: doc.data() })));
      setcustomers(customersSnap.docs.map(doc => ({ id: doc.id, data: doc.data(), label: doc.data().name, value: doc.id })));
      setstaffs(staffsSnap.docs.map(doc => ({ id: doc.id, data: doc.data(), label: doc.data().name, value: doc.id })));

      const unitMap = {};
      unitSnap.docs.forEach(doc => {
        unitMap[doc.id] = doc.data().unit;
      });

      // Realtime: Seating Categories
      onSnapshot(seatingCatsQ, (snapshot) => {
        setseatingCat(snapshot.docs.map(doc => ({ id: doc.id, data: doc.data() })));
      });

      onSnapshot(productsQ, (snapshot) => {
        const productList = snapshot.docs.map(doc => {
          const data = doc.data();
          const unit = data.unit ? unitMap[data.unit] || "" : "";
          return {
            id: doc.id,
            data,
            unit,
            label: `${data.prodname} ${unit}`,
            value: doc.id,
          };
        });
        setproducts(productList);
      });

      // Realtime: Seatings + Associated Booked Orders
      onSnapshot(seatingsQ, async (snapshot) => {
        const seatingsDocs = snapshot.docs;

        const combinedDataPromises = seatingsDocs.map(async (doc1) => {
          const ordersQ = query(
            collection(db, "orders"),
            where("tableid", "==", doc1.id),
            where("status", "==", "Booked"),
            orderBy("created", "asc")
          );

          const orderSnap = await getDocs(ordersQ);
          const orders = orderSnap.docs.map(doc => ({ id: doc.id, data: doc.data() }));

          return {
            id: doc1.id,
            data: doc1.data(),
            status: orders.length > 0 ? "Booked" : "Available",
            orders,
          };
        });

        const combinedData = await Promise.all(combinedDataPromises);
        setseatings(combinedData);
      });

    } catch (error) {
      Toast.fire({
        icon: "error",
        title: error.message,
      });
    }
  };


  const fetchProducts = async (prodcatid) => {
    try {
      // Query: filter by prodcatid and sort by prodname ascending
      const productsQ = query(
        collection(db, 'products'),
        where("prodcatid", "==", prodcatid),
        orderBy("prodname", "asc")
      );

      // Parallel fetch categories and units
      const [catSnap, unitSnap, productSnap] = await Promise.all([
        getDocs(collection(db, 'productcats')),
        getDocs(collection(db, 'productunits')),
        getDocs(productsQ),
      ]);

      // Create maps for quick lookup
      const catMap = {};
      catSnap.forEach(doc => catMap[doc.id] = doc.data().catname);

      const unitMap = {};
      unitSnap.forEach(doc => unitMap[doc.id] = doc.data().unit);

      // Map product data
      const productsList = productSnap.docs.map(doc => {
        const data = doc.data();
        const catname = catMap[data.prodcatid] || "";
        const unit = unitMap[data.unit] || "";

        return {
          id: doc.id,
          data,
          catname,
          unit,
          label: `${catname} - ${data.prodname} ${unit}`,
          value: doc.id,
        };
      });

      setproducts(productsList);

    } catch (error) {
      console.error("Error fetching products:", error);
      Toast.fire({
        icon: "error",
        title: error.message,
      });
    }
  };



  const handleSelectItem = (item) => {
    setitem("");
    setitemid(item.id);
    addOrderItems(item, item.id, item.data.rate)
  };

  const handleSelectItemBarcode = async (barcode) => {
    if (!barcode) {
      setbarcode("");
      return;
    }

    try {
      setbarcode(barcode);

      const q = query(collection(db, 'products'), where("barcode", "==", barcode));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const doc = querySnapshot.docs[0]; // assuming barcode is unique
        const item = { id: doc.id, data: doc.data() };

        addOrderItems(item, doc.id, doc.data().rate);
      } else {
        Toast.fire({
          icon: "warning",
          title: "Product not found for this barcode",
        });
      }
    } catch (error) {
      console.error("Barcode fetch error:", error);
      Toast.fire({
        icon: "error",
        title: error.message,
      });
    }
  };

  const handleSelectItem1 = async (item) => {
    setcustomer(item);
    setcustid(item.id);
    if (orderDocid) {
      await updateDoc(doc(db, 'orders', orderDocid), {
        custid: custid || null,
        customer: customer,
      });
    }

    const q1 = query(collection(db, 'customeracchistory'), where("custid", "==", item.id));
    const snapshot = await getAggregateFromServer(q1, {
      paid: sum('paid')
    });

    const q2 = query(collection(db, 'orders'), where("custid", "==", item.id));
    const snapshot1 = await getAggregateFromServer(q2, {
      totalamount: sum('totalamount')
    });

    const g3 = query(collection(db, 'customeracchistory'), where("custid", "==", item.id));
    const snapshot2 = await getAggregateFromServer(g3, {
      discount: sum('discount')
    });

    let remaining = parseFloat(snapshot1.data().totalamount) - parseFloat(snapshot2.data().discount) - parseFloat(snapshot.data().paid);
    setrevrem(remaining);


  };

  const handleSelectItem2 = async (item) => {
    setstaff(item);
    setstaffid(item.id);
  }

  const addTableId = async (tableid, tablename) => {
    setrevrem(0);
    settableid(tableid); settablename(tablename);
    setorderDocid("");
    setorderitems([]);
    const coll = collection(db, "orders");
    const snapshot = await getCountFromServer(coll, where("orderdate", "==", orderdate));
    let billno = parseFloat(snapshot.data().count) + 1;
    setbillno(billno);

    setcustid(snapshot.data().custid);
    setcustomer("");
    setstaff("");
    setstaffid(snapshot.data().staffid);

    const coll1 = collection(db, "orders");
    const snapshot1 = await getCountFromServer(coll1, where("tableid", "==", tableid), where("orderdate", "==", orderdate));
    let tablebillno = parseFloat(snapshot1.data().count) + 1;
    settablebillno(tablebillno);
  }

  const addTableId1 = async (tableid, tablename, tableno, billno1, orderid, custid, customer, staffid, staff) => {
    fetchOrderItems(tableid, tableno, orderid);
    settablebillno(tableno);
    settableid(tableid);
    settablename(tablename);
    setorderDocid(orderid);
    setbillno(billno1);

    setcustid(custid);
    setcustomer(customer);

    setstaff(staff);
    setstaffid(staffid);

    const q1 = query(collection(db, 'customeracchistory'), where("custid", "==", custid));
    const snapshot = await getAggregateFromServer(q1, {
      paid: sum('paid')
    });

    const q2 = query(collection(db, 'orders'), where("custid", "==", custid));
    const snapshot1 = await getAggregateFromServer(q2, {
      totalamount: sum('totalamount')
    });

    const g3 = query(collection(db, 'customeracchistory'), where("custid", "==", custid));
    const snapshot2 = await getAggregateFromServer(g3, {
      discount: sum('discount')
    });

    let remaining = parseFloat(snapshot1.data().totalamount) - parseFloat(snapshot2.data().discount) - parseFloat(snapshot.data().paid);
    setrevrem(remaining);


  }

  const addOrderItems = async (item, itemid, rate) => {
    try {
      const itemRate = parseFloat(rate);
      const itemName = item.data.prodname;

      let currentOrderId = orderDocid;
      let newTotalAmount = parseFloat(totalamount); // start from current

      // Step 1: Create order if not exists
      if (!currentOrderId) {
        const orderRef = await addDoc(collection(db, 'orders'), {
          tableid,
          custid: custid || null,
          staffid: staffid || null,
          customer,
          staff,
          orderdate,
          tablebillno,
          billno,
          totalamount: 0,
          discount,
          paid,
          remaining,
          paytype,
          status: 'Booked',
          uid: userData.uid,
          created: Timestamp.now()
        });
        currentOrderId = orderRef.id;
        setorderDocid(currentOrderId);
        newTotalAmount = 0; // reset if new order
      }

      // Step 2: Add or update item
      const existingItemQuery = query(
        collection(db, "orderitems"),
        where("orderid", "==", currentOrderId),
        where("itemid", "==", itemid)
      );
      const itemSnapshot = await getDocs(existingItemQuery);

      if (itemSnapshot.empty) {
        await addDoc(collection(db, 'orderitems'), {
          orderid: currentOrderId,
          tableid,
          custid: custid || null,
          staffid: staffid || null,
          customer,
          staff,
          orderdate,
          tablebillno,
          billno,
          itemname: itemName,
          itemid,
          unitname: "",
          quantity: 1,
          rate: itemRate,
          total: itemRate,
          uid: userData.uid,
          created: Timestamp.now()
        });
        newTotalAmount += itemRate;
      } else {
        const existingDoc = itemSnapshot.docs[0];
        const currentQty = parseFloat(existingDoc.data().quantity);
        const newQty = currentQty + 1;
        const oldTotal = parseFloat(existingDoc.data().total);
        const updatedTotal = newQty * itemRate;

        await updateDoc(existingDoc.ref, {
          quantity: newQty,
          total: updatedTotal,
          updated: Timestamp.now()
        });

        newTotalAmount += (updatedTotal - oldTotal);
      }

      // Step 3: Update product stock
      const productRef = doc(db, 'products', itemid);
      const productSnap = await getDoc(productRef);
      if (productSnap.exists()) {
        const currentStock = parseFloat(productSnap.data().stock || 0);
        const updatedStock = currentStock - 1;
        await updateDoc(productRef, { stock: updatedStock });
      }

      // Step 4: Update totalamount in orders table
      await updateDoc(doc(db, 'orders', currentOrderId), {
        totalamount: newTotalAmount
      });

      settotalamount(newTotalAmount); // update local state

      // Step 5: Refresh
      fetchOrderItems(tableid, tablebillno, currentOrderId);
      fetchData1();
      setbarcode("");
      finaltotal();
    } catch (error) {
      console.log("Add Order Item Error:", error.message);
      Toast.fire({ icon: "error", title: error.message });
    }
  };



  const fetchOrderItems = async (tableid, tablebillno, orderid) => {
    try {
      const q = query(
        collection(db, "orderitems"),
        where("tableid", "==", tableid),
        where("tablebillno", "==", tablebillno),
        where("orderid", "==", orderid)
      );

      // 🔄 Real-time listener
      onSnapshot(q, (querySnapshot) => {
        let total = 0;
        const items = [];

        querySnapshot.forEach(doc => {
          const data = doc.data();
          items.push({ id: doc.id, data });

          // Make sure 'total' is treated as number
          const itemTotal = Number(data.total || 0);
          total += itemTotal;
        });

        setorderitems(items);
        settotalamount(total); // 💰 Set total
        console.log("Total:", total);
        finaltotal(); // 👈 Trigger your final calculation logic
      });
    } catch (error) {
      console.error("Error fetching order items or calculating total:", error);
    }
  };


  const deleteOrderItem = async (docid, itemid, quantity, tableid, tablebillno, orderid) => {
    // =============== Product Stock Update ================
    const docProdRef = doc(db, 'products', itemid);
    const docSnap = await getDoc(docProdRef);
    if (docSnap.exists()) {
      let newstock = parseFloat(docSnap.data().stock) + parseFloat(quantity);
      await updateDoc(doc(db, 'products', itemid), {
        stock: newstock,
      });
    }

    const taskDocRef = doc(db, 'orderitems', docid)
    await deleteDoc(taskDocRef);
    const q1 = query(collection(db, 'orderitems'), where("orderid", "==", orderid));
    onSnapshot(q1, async (querySnapshot) => {
      if (querySnapshot.size === 0) {
        const taskDoc2Ref = doc(db, 'orders', orderid)
        await deleteDoc(taskDoc2Ref);
        setorderDocid("")
      }
    });
    fetchData1()
    fetchOrderItems(tableid, tablebillno, orderid);
    // =============== Product Stock Update ================
  }
  const upOrderQty = async (type, docid, itemid, qty, tableid, tablebillno, orderid, rate) => {
    try {
      const itemQty = parseFloat(qty);
      const itemRate = parseFloat(rate);

      if (type === "Remove") {
        // 🟢 Add back to product stock
        const productRef = doc(db, 'products', itemid);
        const productSnap = await getDoc(productRef);
        if (productSnap.exists()) {
          let updatedStock = parseFloat(productSnap.data().stock) + itemQty;
          await updateDoc(productRef, { stock: updatedStock });
        }

        const orderItemRef = doc(db, 'orderitems', docid);
        const orderItemSnap = await getDoc(orderItemRef);
        if (orderItemSnap.exists()) {
          const currentQty = parseFloat(orderItemSnap.data().quantity);
          const newQty = currentQty - itemQty;

          if (newQty < 1) {
            // Delete item
            await deleteDoc(orderItemRef);

            // 🔎 Check if any other items remain in this order
            const remainingItemsSnap = await getDocs(
              query(collection(db, 'orderitems'), where("orderid", "==", orderid))
            );

            if (remainingItemsSnap.empty) {
              // No items left — delete the entire order
              await deleteDoc(doc(db, 'orders', orderid));
              setorderDocid(""); // clear state
            } else {
              // ✅ Items still exist — update order total
              await recalculateOrderTotal(orderid);
            }
          } else {
            // Just update quantity and total
            await updateDoc(orderItemRef, {
              quantity: newQty,
              total: parseFloat(newQty * itemRate)
            });

            await recalculateOrderTotal(orderid);
          }
        }
      } else {
        // Type === "Add"
        // 🔴 Reduce stock
        const productRef = doc(db, 'products', itemid);
        const productSnap = await getDoc(productRef);
        if (productSnap.exists()) {
          let updatedStock = parseFloat(productSnap.data().stock) - itemQty;
          await updateDoc(productRef, { stock: updatedStock });
        }

        const orderItemRef = doc(db, 'orderitems', docid);
        const orderItemSnap = await getDoc(orderItemRef);
        if (orderItemSnap.exists()) {
          const currentQty = parseFloat(orderItemSnap.data().quantity);
          const newQty = currentQty + itemQty;

          await updateDoc(orderItemRef, {
            quantity: newQty,
            total: parseFloat(newQty * itemRate)
          });

          await recalculateOrderTotal(orderid);
        }
      }

      fetchData1();
      fetchOrderItems(tableid, tablebillno, orderid);
    } catch (error) {
      console.log("upOrderQty Error:", error.message);
      Toast.fire({ icon: "error", title: error.message });
    }
  };

  const recalculateOrderTotal = async (orderid) => {
    try {
      const itemsSnap = await getDocs(
        query(collection(db, 'orderitems'), where("orderid", "==", orderid))
      );

      let newTotal = 0;
      itemsSnap.forEach(doc => {
        const item = doc.data();
        newTotal += parseFloat(item.total || 0);
      });

      await updateDoc(doc(db, 'orders', orderid), {
        totalamount: newTotal
      });

      settotalamount(newTotal); // Update local state
      finaltotal(); // Recalculate remaining
    } catch (err) {
      console.error("Error updating order total:", err.message);
    }
  };



  const finaltotal = () => {
    let remainingnew = parseFloat(totalamount) - parseFloat(paid) - parseFloat(discount);
    console.log(totalamount);
    console.log(paid);
    console.log(discount);
    if (remainingnew < 0) {
      Toast.fire({ icon: "error", title: 'Remaining should not be less than 0' });
      setpaid("");
      setremaining(totalamount);
      return;
    }
    if (paid === '') {
      setremaining(totalamount);
    } else {
      setremaining(remainingnew);
    }
  }

  const handleSubmit = async () => {
    await addDoc(collection(db, 'customers'), {
      name: name,
      mobile: mobile,
      address: address,
      uid: userData.uid,
      created: Timestamp.now()
    });
    setname(""); setmobile(""); setaddress("");
    fetchData1()
    Toast.fire({
      icon: "success",
      title: 'Customer Added Successfully!!'
    });
  }

  const saveBill = async () => {
    let rpaid = parseFloat(paid);
    if (totalamount === "" || rpaid === "" || remaining === "") {
      console.log(totalamount, rpaid, remaining);
      Toast.fire({ icon: "error", title: 'Please check the  total amount , paid & Remaining value is correct' });
      return;
    }
    try {
      // --------------------- update status of purchase table --------------------
      await updateDoc(doc(db, 'orders', orderDocid), {
        status: 'Paid',
        custid: custid || null,
        staffid: staffid || null,
        customer: customer,
        staff: staff,
        billno: billno,
        paiddate: orderdate,
        totalamount: totalamount,
        discount: parseFloat(discount),
        paid: parseFloat(paid),
        remaining: remaining,
        paytype: paytype,
      });


      // --------------------- Add dealer account paid amount --------------------
      await addDoc(collection(db, 'customeracchistory'), {
        custid: custid || null,
        staffid: staffid || null,
        customer: customer,
        staff: staff,
        orderDocid: orderDocid,
        billno: billno,
        paiddate: orderdate,
        totalamount: totalamount,
        discount: parseFloat(discount),
        paid: parseFloat(paid),
        remaining: remaining,
        paytype: paytype,
        status: 'Active',
        note: 'Paid at the time bill',
        uid: userData.uid,
        created: Timestamp.now()
      });

      settotalamount("0"); setpaid("0"); setremaining("0"); setorderDocid(""); setcustid(""); setbillno("");
      setpaytype("Cash"); setorderitems([]);

      Toast.fire({ icon: "success", title: 'Order Successfully Paid' });

      window.location.href = "/table-orders";

    } catch (error) {
      Toast.fire({ icon: "error", title: 'Something was wrong please try again' });
      console.log(error.message)
    }
  }





  return (
    <div>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <button className="btn btn-secondary " style={{ float: "right", marginTop: 4 }} >|| Table Orders Management ||</button><br /><br />
            <div className='card'>
              <div className='card-body'>
                <div className='row'>
                  <div className='col-sm-3'>
                    <label>Select Product</label>
                    <Select
                      options={products}
                      value={selectedProduct}
                      onChange={(item) => {
                        setSelectedProduct(item);
                        setCurrentStock(item.data.stock || 0);
                      }}
                    />
                  </div>

                  <div className='col-sm-3'>
                    <label>Available Stock</label>
                    <input
                      type="text"
                      className="form-control"
                      value={currentStock}
                      readOnly
                      style={{
                        backgroundColor:
                          currentStock <= 0
                            ? "#ffcccc"
                            : currentStock <= 5
                              ? "#fff3cd"
                              : "#d4edda",
                        fontWeight: "bold"
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="card card-primary card-outline mt-1">
              <div className="card-body table-responsive p-3" >
                {
                  seatingCat.map((item1, index) =>
                    <div key={index} >
                      <h6 style={{ textTransform: "uppercase", marginLeft: 10 }}><b>{item1.data.catname}</b></h6>
                      <div className="row">
                        {seatings.map((item, index) => {
                          if (item1.id !== item.data.seatcatid) return null;

                          return (
                            <div key={item.id || index} className="col-sm-2">
                              {item.status === 'Booked' ? (
                                <div className="tablebox1">
                                  <h6 className="tablename">
                                    <b>{item.data.seatname}</b>
                                  </h6>

                                  {item.orders.map((order, idx) => (
                                    <button
                                      key={order.id || idx}
                                      className="billbox"
                                      style={{ fontWeight: 700 }}
                                      onClick={() =>
                                        addTableId1(
                                          item.id,
                                          item.data.seatname,
                                          order.data.tablebillno,
                                          order.data.billno,
                                          order.id,
                                          order.data.custid,
                                          order.data.customer,
                                          order.data.staffid,
                                          order.data.staff
                                        )
                                      }
                                      data-toggle="modal"
                                      data-target="#addorder-modal"
                                    >
                                      {order.data.customer?.data?.name || "No Name"}
                                    </button>
                                  ))}

                                  <button
                                    className="billbox"
                                    onClick={() => addTableId(item.id, item.data.seatname)}
                                    data-toggle="modal"
                                    data-target="#addorder-modal"
                                  >
                                    <i className="fa fa-plus"></i>
                                  </button>
                                </div>
                              ) : (
                                <div className="tablebox">
                                  <h6 className="tablename">
                                    <b>{item.data.seatname}</b>
                                  </h6>
                                  <button
                                    className="billbox"
                                    onClick={() => addTableId(item.id, item.data.seatname)}
                                    data-toggle="modal"
                                    data-target="#addorder-modal"
                                  >
                                    <i className="fa fa-plus"></i>
                                  </button>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>

                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="modal fade" id="addorder-modal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header" style={{ backgroundColor: "orangered" }}>
              <h4 className="modal-title" style={{ color: "white" }}>{tablename} Table</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body p-1">
              <div className='row'>
                <div className='col-sm-2 mob-product'>
                  <div className='card' style={{ height: "100%", backgroundColor: "#F9F7F7" }}>
                    <div className='card-body'>
                      {
                        productCat.map((item, index) =>
                          <button key={index} onClick={() => fetchProducts(item.id)} style={{ textTransform: "uppercase", textAlign: "left" }} className='form-control btn btn-info mt-1'>{item.data.catname}</button>
                        )
                      }
                    </div>
                  </div>
                </div>
                <div className='col-sm-6'>
                  <div className='card' style={{ height: "100%", backgroundColor: "#F9F7F7" }}>
                    <div className='card-body'>
                      <div className='row'>
                        <div className='col-sm-6'>
                          <Select options={products} value={item} onChange={handleSelectItem} /><hr />
                        </div>
                        <div className='col-sm-6'>
                          <input className='form-control' placeholder='Enter Barcode' value={barcode} onChange={(e) => handleSelectItemBarcode(e.target.value)} />
                          <hr />
                        </div>
                      </div>
                      <div className='row mob-product'>
                        {
                          products.map((item, index) =>
                            <div key={index} className='col-sm-3'>
                              <button onClick={() => addOrderItems(item, item.id, item.data.rate)} style={{ fontSize: 12, padding: 0 }} className='form-control btn btn-secondary mt-1'> {item.data.prodname} {""}</button>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-sm-4'>
                  <div className='card' style={{ height: "100%" }}>
                    <div className='card-body'>
                      <button className="btn btn-info btn-xs" style={{ float: "right" }} data-toggle="modal" data-target="#customer-modal">Add New Customer</button><br />
                      <div className='row mt-2'>
                        <div className='col-sm-6'>
                          <Select options={customers} value={customer} onChange={handleSelectItem1} />
                          <label>Previous Outstanding Amount : <span style={{ color: "red" }}> Rs.{revrem}/- </span></label>
                        </div>
                        <div className='col-sm-6'>
                          <Select options={staffs} value={staff} onChange={handleSelectItem2} />
                        </div>
                      </div><hr />
                      <div className='row'>
                        <div className='col-sm-6'>
                          <label>Bill No : {billno}</label>
                        </div>
                        <div className='col-sm-6'>
                          <label style={{ float: "right" }}>Date No : {moment(orderdate).format('DD/MM/YYYY')}</label>
                        </div>
                      </div>
                      <div className='productBox '>
                        <table className='table'>
                          {
                            orderitems.map((item, index) =>
                              <tr key={index}>
                                <td>{item.data.itemname}  </td>
                                <td><button onClick={() => upOrderQty('Remove', item.id, item.data.itemid, 1, item.data.tableid, item.data.tablebillno, item.data.orderid, item.data.rate)} className='btn btn-xs btn-info'><i className='fa fa-minus'></i></button></td>
                                <td>{item.data.quantity}</td>
                                <td><button onClick={() => upOrderQty('Add', item.id, item.data.itemid, 1, item.data.tableid, item.data.tablebillno, item.data.orderid, item.data.rate)} className='btn btn-xs btn-info'><i className='fa fa-plus'></i></button></td>
                                <td>{item.data.total}/-</td>
                                <td><button onClick={() => deleteOrderItem(item.id, item.data.itemid, item.data.quantity, item.data.tableid, item.data.tablebillno, item.data.orderid, item.data.rate)} className='btn btn-xs btn-danger'><i className='fa fa-trash'></i></button></td>
                              </tr>
                            )
                          }
                        </table>
                      </div><hr />
                      <div className='col-sm-12'>
                        <h5 style={{ marginBottom: 20 }}>Total Amount :  <span style={{ float: "right" }}>Rs. {totalamount}/-</span> </h5>
                      </div><hr />
                      <div className='row'>
                        <div className='col-sm-4'>
                          <button onClick={handlePrint} className='form-control btn btn-info'>Print  <i className='fa fa-print'></i> </button>
                        </div>
                        <div className='col-sm-4'>
                          <button onClick={() => finaltotal()} data-toggle="modal" data-target="#bill-modal" className='form-control btn btn-success'>Create Bill</button>
                        </div>
                        <div className='col-sm-4'>
                          <button className='form-control btn btn-warning' data-dismiss="modal" aria-label="Close">New Order  </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="modal fade" id="bill-modal">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Create Bill {tablename}</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body">
              <button className="btn btn-info btn-sm" data-toggle="modal" data-target="#customer-modal">Add New Customer</button><hr />
              <div className='row '>
                <div className='col-sm-4'>
                  <label>Select Customer Id  </label>
                  <select className='form-control' style={{ height: 35, fontSize: 14 }} value={custid} onChange={(e) => setcustid(e.target.value)}>
                    <option></option>
                    {customers.map((item) => (
                      <option value={item.id} key={item.id}>{item.data.name}</option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-4">
                  <label>Bill No </label>
                  <input type="text" className="form-control" style={{ height: 35, fontSize: 14 }} value={billno} onChange={(e) => setbillno(e.target.value)} />
                </div>
                <div className="col-sm-4">
                  <label>Bill Date </label>
                  <input type="date" className="form-control" style={{ height: 35, fontSize: 14 }} value={orderdate} onChange={(e) => setorderdate(e.target.value)} />
                </div>
              </div><br />
              <table className='table table-bordered'>
                <tr>
                  <th>Item Name</th>
                  <th>Quantity</th>
                  <th>Rate</th>
                  <th>Total</th>
                </tr>
                {
                  orderitems.map((item, index) =>
                    <tr key={index}>
                      <td>{item.data.itemname}  </td>
                      <td>{item.data.quantity}</td>
                      <td>{item.data.rate}</td>
                      <td>{item.data.total}/-</td>
                    </tr>
                  )
                }
              </table>
              <div className='row '>
                <div className='col-sm-3'>
                  <label>Grand Total </label>
                  <input type="text" className='form-control' style={{ height: 35, fontSize: 14 }} readOnly value={totalamount} />
                </div>
                <div className="col-sm-3">
                  <label>Discount</label>
                  <input type="text" className='form-control' style={{ height: 35, fontSize: 14 }} onKeyUp={() => finaltotal()} value={discount} onChange={(e) => setdiscount(e.target.value)} placeholder='Enter Paid Amount' />
                </div>
                <div className="col-sm-3">
                  <label>Paid</label>
                  <input type="text" className='form-control' style={{ height: 35, fontSize: 14 }} onKeyUp={() => finaltotal()} value={paid} onChange={(e) => setpaid(e.target.value)} placeholder='Enter Paid Amount' />
                </div>
                <div className="col-sm-3">
                  <label>Payment Type</label>
                  <select className='form-control' style={{ height: 35, fontSize: 14 }} value={paytype} onChange={(e) => setpaytype(e.target.value)}>
                    <option value="Cash">Cash</option>
                    <option value="Bank">Bank</option>
                    <option value="RTGS">RTGS</option>
                    <option value="Online Pay">Online Pay</option>
                  </select>
                </div>
                <div className="col-sm-3">
                  <label>Remaining</label>
                  <input type="text" className='form-control' style={{ height: 35, fontSize: 14 }} value={remaining} readOnly />
                </div>
              </div><br></br>
              <center>
                <button onClick={() => saveBill()} className='btn btn-info'>Save Bill</button>
              </center>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="customer-modal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Customer</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-6">
                  <label>  Customer</label>
                  <input type="text" value={name} onChange={(e) => setname(e.target.value)} className="form-control" />
                </div>
                <div className="col-sm-6">
                  <label>Mobile</label>
                  <input type="text" value={mobile} onChange={(e) => setmobile(e.target.value)} className="form-control" />
                </div>
                <div className="col-sm-6 mt-2">
                  <label>Address</label>
                  <input type="text" value={address} onChange={(e) => setaddress(e.target.value)} className="form-control" />
                </div>
              </div><br />
            </div>
            <div className="modal-footer justify-content-between">
              <button type="button" onClick={() => handleSubmit()} className="btn btn-primary" data-dismiss="modal">Save </button>
              <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="bill-modal">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Print Bill {tablename}</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body">
              {/* ==================================== Print Bill ==================================== */}

              <div style={{ padding: 20 }} ref={printRef}>
                <center>
                  <h6>Pratik Bar & Restaurent</h6>
                  <span>Bhavani Chouk, Tuljapur By Pass, Dharashiv. 413 601</span><br />
                  <span>Mobile No: 9156931633, 9511885070</span>
                </center>
                <div className='row'>
                  <div className='col-sm-6'>
                    <label>Bill No : {billno}</label>
                  </div>
                  <div className='col-sm-6'>
                    <label style={{ float: "right" }}>Date No : {moment(orderdate).format('DD/MM/YYYY')}</label>
                  </div>
                </div><hr />
                <table width="100%">
                  <tr>
                    <th>Item Name</th>
                    <th>Quantity</th>
                    <th>Rate</th>
                    <th>Total</th>
                  </tr>
                  {
                    orderitems.map((item, index) =>
                      <tr key={index}>
                        <td>{item.data.itemname}  </td>
                        <td>{item.data.quantity}</td>
                        <td>{item.data.rate}</td>
                        <td>{item.data.total}/-</td>
                      </tr>
                    )
                  }
                </table>
                <hr />
                <div>
                  <h6 style={{ marginBottom: 20 }}>Total Amount :  <span style={{ float: "right" }}>Rs. {totalamount}/-</span> </h6>
                </div>
                <center>
                  <i>Thank You! Visit Again.</i><br />
                  <i>Software by Bluevipers Technology. (8459432930)</i>
                </center>
              </div>



            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default TableOrders
